<template>
  <b-table
    :data="data"
    :loading="isLoading"
    paginated
    backend-pagination
    :total="total"
    :per-page="perPage"
    @page-change="onPageChange"
    aria-next-label="Próxima Página"
    aria-previous-label="Página Anterior"
    aria-page-label="Página"
    aria-current-label="Página Atual"
  >
    <template slot-scope="props">
      <b-table-column field="created_at" label="Data" numeric>
        {{ props.row.created_at | date('LL') }}
      </b-table-column>
      <b-table-column
        field="from"
        label="Pontos"
        class="points"
        :class="{ credit: props.row.points > 0 }"
      >
        {{ props.row.points }}
      </b-table-column>
      <b-table-column field="type" label="Tipo">
        {{ props.row.type }}
      </b-table-column>
    </template>
    <template slot="empty">
      <section>
        <h1 id="no-results">Sem resultados.</h1>
      </section>
    </template>
  </b-table>
</template>

<script>
import PointTransactionService from '@/services/point-transaction.service';

export default {
  name: 'points-extract-table',
  props: ['id'],
  data: () => {
    return {
      data: [],
      total: 0,
      isLoading: true,
      page: 1,
      perPage: 10,
    };
  },
  methods: {
    load() {
      this.isLoading = true;

      PointTransactionService.get(this.id, {
        page: this.page,
        perPage: this.perPage,
      })
        .then((response) => {
          const { total, data } = response.data;

          this.total = total;
          this.data = data;
        })
        .finally(() => (this.isLoading = false));
    },
    onPageChange(page) {
      this.page = page;
      this.load();
    },
  },
  mounted() {
    this.load();
  },
};
</script>
